import React from 'react';
import ChooseAccountsStep from 'components/AccountConnectionFlow/ChooseAccountsStep';

const ActivateMetaAccountsStep = (props) => {
  return <ChooseAccountsStep />;
};

export default ActivateMetaAccountsStep;
